<div class="payapp-container">
  <!-- Actions Bar -->
  @if (!isSearchActive) {
    <div class="actions-bar" >
      <mat-form-field class="payapp-dropdown no-border">
        <mat-select data-testid="payapp-select" [(value)]="selectedPayapp" (selectionChange)="onPayappChange($event.value)" [compareWith]="comparePayapps" class="panel" disableOptionCentering panelClass="payapp-list-panel">
          <mat-select-trigger>
            <span class="payapp-trigger"
              [matTooltip]="selectedPayapp?.name || (selectedPayapp?.estimate_number ? 'Pay Estimate' : selectedPayapp?.id === 'unpaid' ? 'Unpaid' : '')"
              matTooltipPosition="left"
              matTooltipClass="payapp-tooltip"
              [matTooltipDisabled]="!isPayappNameTruncated">
              <span class="payapp-name" #payappNameEl>{{ selectedPayapp?.name || (selectedPayapp?.estimate_number ? 'Pay Estimate' : selectedPayapp?.id === 'unpaid' ? 'Unpaid' : '') }}</span>
              @if (selectedPayapp?.estimate_number && !useLegacyLayout) {
                <span class="payapp-estimate">
                  #{{ selectedPayapp.estimate_number }}
                </span>
              }
            </span>
          </mat-select-trigger>
          @for (p of payapps; track p) {
            <mat-option [value]="p" [attr.data-testid]="'payapp-option-' + p.id"
              [matTooltip]="getPayappTooltip(p)"
              matTooltipPosition="left"
              matTooltipClass="payapp-tooltip">
              <div class="payapp-option">
                <div class="payapp-option-main">
                  <span class="payapp-option-name">{{ p.name || (p.estimate_number ? 'Pay Estimate' : '') }}</span>
                  @if (p.estimate_number && !useLegacyLayout) {
                    <span class="payapp-option-estimate">#{{ p.estimate_number }}</span>
                  }
                </div>
                @if (p.start_date || p.calculated?.amount_due_this_period) {
                  <div class="payapp-option-details">
                    @if (p.start_date && p.end_date) {
                      <span class="payapp-option-date">
                        {{ p.start_date | date: 'MMM d':'UTC' }} - {{ p.end_date | date: 'MMM d, y':'UTC' }}
                      </span>
                    }
                    @if (p.calculated?.amount_due_this_period) {
                      <span class="payapp-option-amount">
                        {{ p.calculated.amount_due_this_period | currency:'USD':'symbol':'1.0-0' }}
                      </span>
                    }
                  </div>
                }
              </div>
            </mat-option>
          }
        </mat-select>
        <mat-icon
          class="suffix-icon"
          svgIcon="chevron-down"
          matSuffix
          />
      </mat-form-field>
      <app-payapp-date-filter #dateFilter
        (dateChanged)="onDateChanged($event)"
      ></app-payapp-date-filter>
      <app-payapp-multi-filter #multiFilter
        (filtersChanged)="onFiltersChanged($event)"
        [projectId]="projectDetails?.id || null"
        [isContractorMode]="isContractorMode"
        />
      @if (selectedSortColumn) {
        <div class="sort-dropdown-container">
          <mat-select [(value)]="selectedSortColumn" (selectionChange)="onSortColumnChange($event)" disableOptionCentering panelClass="payapp-sort-panel" class="sort-select">
            <mat-select-trigger>
              {{ 'Sort by: ' + selectedSortColumn }}
            </mat-select-trigger>
            @for (column of (showG703View ? g703SortByColumns : sortByColumns); track column) {
              <mat-option [value]="column">
                {{ column }}
              </mat-option>
            }
          </mat-select>
          <mat-icon class="sort-direction" (click)="toggleSortDirection(); $event.stopPropagation()">
            {{ sortDirection === 'asc' ? 'arrow_upward' : 'arrow_downward' }}
          </mat-icon>
          <mat-icon class="sort-close" (click)="removeSort($event)">
            close
          </mat-icon>
        </div>
      }
      @if (!selectedSortColumn) {
        <mat-form-field class="sort-dropdown nosort">
          <mat-select [(value)]="selectedSortColumn" (selectionChange)="onSortColumnChange($event)" disableOptionCentering panelClass="payapp-sort-panel">
            @for (column of (showG703View ? g703SortByColumns : sortByColumns); track column) {
              <mat-option [value]="column">
                {{ column }}
              </mat-option>
            }
          </mat-select>
          <div class="label text-type-8">Sort: </div>
          <mat-icon>sync_alt</mat-icon>
        </mat-form-field>
      }
      <mat-icon class="search-icon" matPrefix>search</mat-icon>
      <input
        type="text"
        class="search-bar"
        placeholder="Search"
        [formControl]="searchControl"
        #searchInput
        (click)="onSearchClick($event)"
        />
      @if (projectDetails?.enable_moh_per_item) {
        @if (downloadingMohLedger) {
          <div class="download-spinner-wrapper moh-ledger-download-spinner">
            <mat-spinner
              color="primary"
              diameter="24"
              mode="indeterminate"
              strokeWidth="3"
            >
            </mat-spinner>
          </div>
        } @else {
          <button
            mat-icon-button
            class="download-button moh-ledger-download"
            type="button"
            matTooltip="Download material on hand ledger"
            matTooltipClass="project-name-tooltip"
            (click)="downloadMohLedger()"
          >
            <mat-icon>inventory_2</mat-icon>
          </button>
        }
      }
      @if (canEdit && !readOnly && !isContractorMode) {
        <button
          mat-stroked-button [disabled]="!hasReadyItems || hasContractOverage" class="generate-button" data-testid="payapp-generate" (click)="generatePayapp()">
          Generate payapp
        </button>
      } @else {
        @if (canEdit && !isContractorMode) {
          <button mat-stroked-button class="delete-button" color="primary" (click)="confirmDeletePayapp()">
            Recall payapp
          </button>
        }
      }
    </div>
  }

  <!-- Search Bar Full Width -->
  @if (isSearchActive) {
    <div class="search-bar-full" >
      <div class="search-container">
        <mat-icon matPrefix>search</mat-icon>
        <input
          type="text"
          class="search-bar full-width"
          placeholder="Search by site name"
          [formControl]="searchControl"
          #searchInputFull
          />
        <button mat-icon-button class="clear-search" (click)="clearSearch()">
          <mat-icon>clear</mat-icon>
        </button>
        <button
          *ngIf="!downloading && selectedPayapp && selectedPayapp.id !== 'unpaid' && hasExcelDownload"
          class="download-button"
          mat-icon-button
          [matMenuTriggerFor]="downloadMenu"
         
          title="Download"
        >
          <mat-icon>download</mat-icon>
        </button>
        <mat-menu #downloadMenu="matMenu">
          <button mat-menu-item (click)="downloadPayapp('pdf')">
            <mat-icon>picture_as_pdf</mat-icon>
            <span>Download PDF</span>
          </button>
          <button mat-menu-item (click)="downloadPayapp('excel')">
            <mat-icon>table_chart</mat-icon>
            <span>Download Excel</span>
          </button>
        </mat-menu>
      </div>
    </div>
  }

  @if (!readOnly && !isContractorMode && (deferredItems.length || showDeferredItems || priorPeriodItems.length || hasContractOverage || showPartialPaymentReview)) {
    <div class="payapp-notice" role="status" data-testid="payapp-review-summary">
      <mat-icon class="payapp-notice-icon" svgIcon="warning" aria-hidden="true" />
      <div class="payapp-notice-copy">
        @if (hasContractOverage || showPartialPaymentReview) {
          <span data-testid="payapp-contract-warning">{{ deferralReviewMessage }}</span>
        }
        @if (deferredItems.length || showDeferredItems) {
          <span data-testid="payapp-deferred-summary">{{ deferredItems.length }} {{ deferredItems.length === 1 ? 'item has' : 'items have' }} deferred quantity</span>
        }
        @if (priorPeriodItems.length) {
          <span data-testid="payapp-outstanding">{{ priorPeriodItems.length }} earlier unpaid or deferred {{ priorPeriodItems.length === 1 ? 'item' : 'items' }}</span>
        }
      </div>
      <div class="payapp-notice-actions">
        @if (hasContractOverage || showPartialPaymentReview) {
          <button type="button" class="payapp-notice-action" data-testid="payapp-review-partial" (click)="togglePartialPaymentReview()">
            {{ showPartialPaymentReview ? 'Show current items' : deferralReviewAction }}
          </button>
        }
        @if (deferredItems.length || showDeferredItems) {
          <button type="button" class="payapp-notice-action" data-testid="payapp-review-deferred" (click)="toggleDeferredItems()">
            {{ showDeferredItems ? 'Show current items' : 'Review deferred (' + deferredItems.length + ')' }}
          </button>
        }
        @if (priorPeriodItems.length) {
          <button type="button" class="payapp-notice-action" data-testid="payapp-review-outstanding" (click)="toggleOutstanding()">
            {{ showOutstanding ? 'Show current items' : 'Review earlier items' }}
          </button>
        }
      </div>
    </div>
  }

  @if (!readOnly && includedPriorItems.size) {
    <p class="payapp-selection-note" data-testid="payapp-inclusion-note">
      {{ includedPriorItems.size }} earlier {{ includedPriorItems.size === 1 ? 'item is' : 'items are' }} included in this pay app@if (startDate && endDate) { for {{ startDate | date:'MMM d' }} – {{ endDate | date:'MMM d, y' }}}.
      The original work dates stay unchanged. This selection clears when you leave this page or change the date range.
    </p>
  }

  @if (searchControl.value) {
    <div class="summary-hdr">
      <span class="label">{{ showG703View ? groupedItems?.length : displayedItems?.length }} results</span>
    </div>
  }

  @if (!searchControl.value) {
    <div class="summary-hdr">
      <div class="summary-content">
        <span class="label">Total: {{ totalAmount | currency:'USD' }} USD</span>
        <span class="flex-spacer"></span>
        <!-- Download button positioned at the same level as total -->
        <div class="download-button-container">
          @if (downloading) {
            <div class="download-spinner-wrapper">
              <mat-spinner
                color="primary"
                diameter="24"
                mode="indeterminate"
                strokeWidth="3"
                >
              </mat-spinner>
            </div>
          }
          @if (!downloading && selectedPayapp && selectedPayapp.id !== 'unpaid' && !hasExcelDownload) {
            <button
              (click)="downloadPayapp()"
              class="download-button"
              mat-icon-button
              title="Download PDF"
              >
              <mat-icon>download</mat-icon>
            </button>
          }
          @if (!downloading && selectedPayapp && selectedPayapp.id !== 'unpaid' && hasExcelDownload) {
            <button
              class="download-button"
              mat-icon-button
              [matMenuTriggerFor]="summaryDownloadMenu"
              title="Download"
              >
              <mat-icon>download</mat-icon>
            </button>
            <mat-menu #summaryDownloadMenu="matMenu">
              <button mat-menu-item (click)="downloadPayapp('pdf')">
                <mat-icon>picture_as_pdf</mat-icon>
                <span>Download PDF</span>
              </button>
              <button mat-menu-item (click)="downloadPayapp('excel')">
                <mat-icon>table_chart</mat-icon>
                <span>Download Excel</span>
              </button>
            </mat-menu>
          }
        </div>
      </div>
    </div>
  }

  <!-- Pay App Summary (shown for submitted pay apps; hidden in legacy mode unless there are deductions/adjustments) -->
  @if (selectedPayapp && selectedPayapp.id !== 'unpaid' && !searchControl.value && (!useLegacyLayout || hasAdjustments)) {
    <mat-expansion-panel
      [expanded]="summaryExpanded"
      (expandedChange)="onSummaryExpandedChange($event)"
      class="summary-accordion"
      >
      <mat-expansion-panel-header>
        <mat-panel-title>
          Pay App Summary
        </mat-panel-title>
        @if (!summaryExpanded && payappSummary?.calculated) {
          <mat-panel-description>
            @if (selectedPayapp?.start_date && selectedPayapp?.end_date) {
              <span class="collapsed-summary-item">
                {{ selectedPayapp.start_date | date:'MMM d':'UTC' }} - {{ selectedPayapp.end_date | date:'MMM d, y':'UTC' }}
              </span>
            }
            <span class="collapsed-summary-item">
              Earnings to Date: {{ payappSummary.calculated.work_completed_to_date | currency:'USD':'symbol':'1.0-0' }}
            </span>
            @if (payappSummary.calculated.total_deductions > 0) {
              <span class="collapsed-summary-item deduction">
                Deductions: ({{ payappSummary.calculated.total_deductions | currency:'USD':'symbol':'1.0-0' }})
              </span>
            }
          </mat-panel-description>
        }
      </mat-expansion-panel-header>
      <app-pay-app-summary
        [payApp]="selectedPayapp"
        [summary]="payappSummary"
        [billingSettings]="billingSettings"
      ></app-pay-app-summary>
    </mat-expansion-panel>
  }

  <!-- G703 Grouped View for Submitted Pay Apps -->
  @if (showG703View && groupedItems?.length > 0) {
    <div class="g703-grouped-view">
      <!-- Header Row -->
      <div class="g703-header-row">
        <div class="g703-expand-col"></div>
        <div class="g703-item-col g703-sortable" (click)="sortOnColumn('Item')">
          Item
          @if (selectedSortColumn === 'Item') {
            <mat-icon class="g703-sort-arrow">{{ sortDirection === 'asc' ? 'arrow_upward' : 'arrow_downward' }}</mat-icon>
          }
        </div>
        <div class="g703-desc-col">Description</div>
        <div class="g703-unit-col">Unit</div>
        <div class="g703-num-col text-right">Orig Qty</div>
        <div class="g703-num-col text-right">CO Qty</div>
        <div class="g703-num-col text-right">Adj Qty</div>
        <div class="g703-num-col text-right g703-sortable" (click)="sortOnColumn('This Period')">
          This Prd
          @if (selectedSortColumn === 'This Period') {
            <mat-icon class="g703-sort-arrow">{{ sortDirection === 'asc' ? 'arrow_upward' : 'arrow_downward' }}</mat-icon>
          }
        </div>
        <div class="g703-num-col text-right">Previous</div>
        <div class="g703-num-col text-right g703-sortable" (click)="sortOnColumn('To Date')">
          To Date
          @if (selectedSortColumn === 'To Date') {
            <mat-icon class="g703-sort-arrow">{{ sortDirection === 'asc' ? 'arrow_upward' : 'arrow_downward' }}</mat-icon>
          }
        </div>
        <div class="g703-pct-col text-right g703-sortable" (click)="sortOnColumn('% Complete')">
          % Compl
          @if (selectedSortColumn === '% Complete') {
            <mat-icon class="g703-sort-arrow">{{ sortDirection === 'asc' ? 'arrow_upward' : 'arrow_downward' }}</mat-icon>
          }
        </div>
        @if (hasMohLedger) {
          <div class="g703-materials-col text-right">Materials</div>
        }
        <div class="g703-price-col text-right g703-sortable" (click)="sortOnColumn('Unit Price')">
          Unit Price
          @if (selectedSortColumn === 'Unit Price') {
            <mat-icon class="g703-sort-arrow">{{ sortDirection === 'asc' ? 'arrow_upward' : 'arrow_downward' }}</mat-icon>
          }
        </div>
        <div class="g703-amt-col text-right g703-sortable" (click)="sortOnColumn('Amount')">
          Amount
          @if (selectedSortColumn === 'Amount') {
            <mat-icon class="g703-sort-arrow">{{ sortDirection === 'asc' ? 'arrow_upward' : 'arrow_downward' }}</mat-icon>
          }
        </div>
        @if (retainagePercentage > 0) {
          <div class="g703-retainage-col text-right">Retainage</div>
        }
      </div>
      <!-- Grouped Rows (paginated) -->
      @for (group of displayedGroupedItems; track group) {
        <!-- Summary Row -->
        <div class="g703-summary-row" (click)="toggleBidItemExpand(group.item)" [attr.data-testid]="'moh-ledger-row-' + group.item">
          <div class="g703-expand-col">
            <mat-icon class="expand-chevron" [class.expanded]="isBidItemExpanded(group.item)">
              chevron_right
            </mat-icon>
          </div>
          <div class="g703-item-col">{{ group.item }}</div>
          <div class="g703-desc-col">
            <span #descSpan #descTooltip="matTooltip" [matTooltip]="group.description" [matTooltipDisabled]="true" (mouseenter)="descTooltip.disabled = !isEllipsisActive(descSpan)" matTooltipClass="g703-detail-tooltip white-tooltip">{{ group.description }}</span>
            @if (group.moh) {
              <span class="moh-attachment-count" [attr.data-testid]="'moh-attachment-count-' + group.item">
                <mat-icon>attach_file</mat-icon>
                {{ getMohAttachments(group).length }}
              </span>
            }
            @if (!isSingleSiteProject) {
              <div class="detail-count">{{ group.siteCountNum }} {{ group.siteCountNum === 1 ? 'site' : 'sites' }}</div>
            }
          </div>
          <div class="g703-unit-col">{{ group.uom }}</div>
          <div class="g703-num-col text-right">{{ group.original_quantity | number:'1.2-2' }}</div>
          <div class="g703-num-col text-right">{{ group.change_order_quantity | number:'1.2-2' }}</div>
          <div class="g703-num-col text-right">{{ group.adjusted_quantity | number:'1.2-2' }}</div>
          <div class="g703-num-col text-right">{{ group.quantity | number:'1.2-2' }}</div>
          <div class="g703-num-col text-right">{{ group.quantity_previous | number:'1.2-2' }}</div>
          <div class="g703-num-col text-right">{{ group.quantity_to_date | number:'1.2-2' }}</div>
          <div class="g703-pct-col text-right">{{ group.percent_complete | number:'1.1-1' }}%</div>
          @if (hasMohLedger) {
            <div class="g703-materials-col text-right" [attr.data-testid]="'moh-materials-summary-' + group.item">
              <span class="materials-primary">{{ (group.moh?.F || 0) | currency:'USD':'symbol':'1.0-0' }}</span>
              @if (group.moh) {
                <span
                  class="materials-secondary"
                  matTooltip="Net change in materials on hand this period (added − drawn down)"
                  matTooltipPosition="above"
                  matTooltipClass="project-name-tooltip"
                >
                  Δ {{ ((group.moh?.advance_added || 0) - (group.moh?.drawdown || 0)) | currency:'USD':'symbol':'1.0-0' }}
                  @if (getMohAttachments(group).length) {
                    <span class="materials-attachment-count">
                      <mat-icon>attach_file</mat-icon>
                      {{ getMohAttachments(group).length }}
                    </span>
                  }
                </span>
              }
            </div>
          }
          <div class="g703-price-col text-right">{{ group.unit_price | currency:'USD':'symbol':'1.0-0' }}</div>
          <div class="g703-amt-col text-right">{{ group.amount | currency:'USD':'symbol':'1.0-0' }}</div>
          @if (retainagePercentage > 0) {
            <div class="g703-retainage-col text-right">{{ group.quantity_to_date * group.unit_price * (retainagePercentage / 100) | currency:'USD':'symbol':'1.0-0' }}</div>
          }
        </div>
        <!-- Detail Rows (shown when expanded) -->
        @if (isBidItemExpanded(group.item)) {
          @if (group.moh) {
            <div class="moh-attachments-panel" [attr.data-testid]="'moh-attachments-panel-' + group.item">
              <div class="moh-detail-main">
                <div class="moh-detail-metrics">
                  <div
                    class="moh-detail-metric"
                    matTooltip="Materials on hand at the start of this period"
                    matTooltipPosition="above"
                    matTooltipClass="project-name-tooltip"
                  >
                    <span>Prev stored</span>
                    <strong>{{ ((group.moh?.F || 0) - (group.moh?.advance_added || 0) + (group.moh?.drawdown || 0)) | currency:'USD' }}</strong>
                  </div>
                  <div
                    class="moh-detail-metric"
                    matTooltip="Stored materials added in this pay application period"
                    matTooltipPosition="above"
                    matTooltipClass="project-name-tooltip"
                  >
                    <span>Added this period</span>
                    <strong>{{ (group.moh?.advance_added || 0) | currency:'USD' }}</strong>
                  </div>
                  <div
                    class="moh-detail-metric"
                    matTooltip="Stored materials drawn down in this pay application period"
                    matTooltipPosition="above"
                    matTooltipClass="project-name-tooltip"
                  >
                    <span>Drawdown</span>
                    <strong>{{ (group.moh?.drawdown || 0) | currency:'USD' }}</strong>
                  </div>
                  <div
                    class="moh-detail-metric"
                    matTooltip="Materials on hand balance after this pay application (F)"
                    matTooltipPosition="above"
                    matTooltipClass="project-name-tooltip"
                  >
                    <span>Stored to date</span>
                    <strong>{{ (group.moh?.F || 0) | currency:'USD' }}</strong>
                  </div>
                  <div
                    class="moh-detail-metric"
                    matTooltip="Installed work for this bid item in the current pay application period"
                    matTooltipPosition="above"
                    matTooltipClass="project-name-tooltip"
                  >
                    <span>Installed this period</span>
                    <strong>{{ (group.moh?.E || group.amount || 0) | currency:'USD' }}</strong>
                  </div>
                  <div
                    class="moh-detail-metric"
                    matTooltip="Total completed and stored to date (G) = work in place + stored to date"
                    matTooltipPosition="above"
                    matTooltipClass="project-name-tooltip"
                  >
                    <span>Completed + stored</span>
                    <strong>{{ (group.moh?.G || (group.amount + (group.moh?.F || 0))) | currency:'USD' }}</strong>
                  </div>
                </div>
                <span class="moh-attachments-title">Material attachments</span>
                @if (getMohAttachments(group).length) {
                  <div class="moh-attachment-list">
                    @for (attachment of getMohAttachments(group); track attachment) {
                      <a
                        class="moh-attachment-thumb"
                        [href]="getMohAttachmentUrl(attachment)"
                        target="_blank"
                        rel="noopener"
                        (click)="$event.stopPropagation()"
                        [attr.data-testid]="'moh-attachment-' + group.item"
                      >
                        @if (hasMohAttachmentThumb(attachment)) {
                          <img [src]="getMohAttachmentPreview(attachment)" [alt]="getMohAttachmentName(attachment)">
                        } @else {
                          <div class="moh-document-thumb">
                            <mat-icon>description</mat-icon>
                          </div>
                        }
                        <span>{{ getMohAttachmentName(attachment) }}</span>
                      </a>
                      @if (canEditMohAttachments()) {
                        <button
                          mat-icon-button
                          class="moh-attachment-delete"
                          type="button"
                          (click)="deleteMohAttachment(group, attachment); $event.stopPropagation()"
                          [attr.data-testid]="'moh-attachment-delete-' + group.item"
                        >
                          <mat-icon>close</mat-icon>
                        </button>
                      }
                    }
                  </div>
                } @else {
                  <span class="moh-attachments-empty">No attachments</span>
                }
              </div>
              @if (canEditMohAttachments()) {
                @if (mohAttachmentUploading[group.moh.uuid]) {
                  <div class="moh-upload-spinner-wrapper" [attr.data-testid]="'moh-attachment-upload-spinner-' + group.item">
                    <mat-spinner color="primary" diameter="24" mode="indeterminate" strokeWidth="3" />
                  </div>
                } @else {
                  <button
                    mat-icon-button
                    type="button"
                    class="moh-upload-button"
                    title="Upload material attachment"
                    aria-label="Upload material attachment"
                    (click)="mohUploadInput.click(); $event.stopPropagation()"
                    [attr.data-testid]="'moh-attachment-upload-' + group.item"
                  >
                    <mat-icon>attach_file</mat-icon>
                  </button>
                }
                <input
                  #mohUploadInput
                  type="file"
                  class="hidden"
                  multiple
                  accept=".pdf,.png,.jpg,.jpeg"
                  (change)="onMohAttachmentSelected($event, group)"
                  [attr.data-testid]="'moh-attachment-input-' + group.item"
                />
              }
            </div>
          }
          <!-- Detail Header -->
          <div class="g703-detail-header">
            <div class="g703-expand-col"></div>
            <div class="g703-detail-context">
              <span class="detail-date">Date</span>
              @if (!isSingleSiteProject) {
                <span class="detail-site">Site</span>
              }
              <span class="detail-creator">Created By</span>
            </div>
            <div class="g703-num-col text-right">Qty</div>
            <div class="g703-pct-col text-right"></div>
            <div class="g703-amt-col text-right">Amount</div>
            <div class="g703-price-col text-right"></div>
            @if (retainagePercentage > 0) {
              <div class="g703-retainage-col text-right"></div>
            }
          </div>
          <!-- Detail Data Rows -->
          @for (detail of group.details; track detail) {
            <div class="g703-detail-row">
              <div class="g703-expand-col"></div>
              <div class="g703-detail-context">
                <span class="detail-date">{{ detail.report_date | date:'MMM d, y' }}</span>
                @if (!isSingleSiteProject) {
                  <span class="detail-site" #siteSpan #siteTooltip="matTooltip"
                    [matTooltip]="detail.site_name"
                    [matTooltipDisabled]="true"
                    (mouseenter)="siteTooltip.disabled = !isEllipsisActive(siteSpan)"
                  matTooltipClass="g703-detail-tooltip white-tooltip">{{ detail.site_name }}</span>
                }
                <span class="detail-creator" #creatorSpan #creatorTooltip="matTooltip"
                  [matTooltip]="detail.created_by_name"
                  [matTooltipDisabled]="true"
                  (mouseenter)="creatorTooltip.disabled = !isEllipsisActive(creatorSpan)"
                matTooltipClass="g703-detail-tooltip white-tooltip">{{ detail.created_by_name }}</span>
              </div>
              <div class="g703-num-col text-right">{{ detail.quantity | number:'1.2-2' }}</div>
              <div class="g703-pct-col text-right"></div>
              <div class="g703-amt-col text-right">{{ detail.quantity * detail.unit_price | currency:'USD' }}</div>
              <div class="g703-price-col text-right"></div>
              @if (retainagePercentage > 0) {
                <div class="g703-retainage-col text-right"></div>
              }
            </div>
          }
        }
        <div class="g703-row-divider"></div>
      }
    </div>
  }

  <!-- No Data for G703 View -->
  @if (showG703View && (!groupedItems || groupedItems.length === 0)) {
    <div class="no-data">
      No records found.
    </div>
  }

  <!-- Payapp Items Table (Unpaid View) -->
  @if (!showG703View && displayedItems?.length > 0) {
    <div>
      <table mat-table [dataSource]="displayedItems" class="mat-elevation-z0 payapp-table">
        <!-- Columns -->
        <ng-container matColumnDef="Date">
          <th mat-header-cell *matHeaderCellDef>Date
            @if (selectedSortColumn === 'Date') {
              <span>
                <mat-icon (click)="toggleSortDirection()" class="sort-column">{{ sortDirection === 'asc' ? 'arrow_upward' : 'arrow_downward' }}</mat-icon>
              </span>
            }
          </th>
          <td class="date" mat-cell *matCellDef="let element">
            {{ element.report_date | date: 'MMM d, y' }}
            @if (!readOnly && includedPriorItems.has(element.report_bid_item_id)) {
              <div class="comment-text" data-testid="payapp-earlier-included">Earlier work included</div>
            }
          </td>
        </ng-container>
        <ng-container matColumnDef="Site">
          <th mat-header-cell *matHeaderCellDef>Site
            @if (selectedSortColumn === 'Site') {
              <span>
                <mat-icon (click)="toggleSortDirection()" class="sort-column">{{ sortDirection === 'asc' ? 'arrow_upward' : 'arrow_downward' }}</mat-icon>
              </span>
            }
          </th>
          <td mat-cell *matCellDef="let element">
            <div class="site">{{ element.site_name }}</div>
          </td>
        </ng-container>
        <ng-container matColumnDef="Created By">
          <th mat-header-cell *matHeaderCellDef>Created by
            @if (selectedSortColumn === 'Created By') {
              <span>
                <mat-icon (click)="toggleSortDirection()" class="sort-column">{{ sortDirection === 'asc' ? 'arrow_upward' : 'arrow_downward' }}</mat-icon>
              </span>
            }
          </th>
          <td mat-cell *matCellDef="let element">{{ element.created_by_name || element.created_by }}</td>
        </ng-container>
        <ng-container matColumnDef="Bid Item">
          <th mat-header-cell *matHeaderCellDef>Bid item
            @if (selectedSortColumn === 'Bid Item') {
              <span>
                <mat-icon (click)="toggleSortDirection()" class="sort-column">{{ sortDirection === 'asc' ? 'arrow_upward' : 'arrow_downward' }}</mat-icon>
              </span>
            }
          </th>
          <td mat-cell *matCellDef="let element">{{ element.item }}
            <div class="item-descr" #itemDescr #itemTooltip="matTooltip" [matTooltip]="element.description" [matTooltipDisabled]="true" (mouseenter)="itemTooltip.disabled = !isEllipsisActive(itemDescr)" matTooltipClass="g703-detail-tooltip white-tooltip">{{ element.description }}</div>
          </td>
        </ng-container>
        <ng-container matColumnDef="Quantity">
          <th mat-header-cell *matHeaderCellDef>Quantity
            @if (selectedSortColumn === 'Quantity') {
              <span>
                <mat-icon (click)="toggleSortDirection()" class="sort-column">{{ sortDirection === 'asc' ? 'arrow_upward' : 'arrow_downward' }}</mat-icon>
              </span>
            }
          </th>
          <td mat-cell *matCellDef="let element">
            <span
              class="quantity"
              [ngClass]="{'disagree-qty': element.contractor_status === 'disagree'}"
              (click)="!isOutsidePaymentSelection(element) && openContractorStatusDialog(element.report_bid_item_id)"
              >
              @if (element.contractor_status === 'disagree') {
                <mat-icon
                  svgIcon="open-issues"
                  class="disagree-icon"
                  />
              }
              @if (showQuantityBreakdown(element)) { <span class="quantity-label">Recorded:</span> }
              {{ (!readOnly && !isContractorMode ? (element.reported_quantity ?? element.quantity) : element.quantity) | number:'1.0-8' }}
            </span>
            @if (showQuantityBreakdown(element)) {
              <div class="quantity-allocation">
                @if (element.paid_quantity) {
                  <span>Already paid: {{ element.paid_quantity | number:'1.0-8' }}</span>
                }
                @if (isOutsidePaymentSelection(element)) {
                  @if (element.paid_quantity) { <span>Unpaid: {{ element.quantity | number:'1.0-8' }} {{ element.uom }}</span> }
                  @if (deferredQuantity(element) > 0) { <span>Deferred: {{ deferredQuantity(element) | number:'1.0-8' }} {{ element.uom }}</span> }
                } @else {
                <span class="quantity-payable" data-testid="payapp-payable-quantity">Payable now: {{ contractPayableQuantity(element) | number:'1.0-8' }}</span>
                @if (needsPartialPaymentReview(element)) {
                  <span class="contract-warning" data-testid="payapp-item-over-contract">{{ contractPayableQuantity(element) <= 0 ? 'Must be deferred in full' : 'Needs partial deferral' }}: {{ element.quantity - contractPayableQuantity(element) | number:'1.0-8' }} {{ element.uom }} · Reason required</span>
                  <span>Contract: {{ element.adjusted_quantity | number:'1.0-8' }} · Previously billed: {{ element.quantity_previous | number:'1.0-8' }}</span>
                } @else if (element.quantity > contractPayableQuantity(element) && statusMap[element.report_bid_item_id] !== 'rejected') {
                  <span>Deferred: {{ element.quantity - contractPayableQuantity(element) | number:'1.0-8' }} {{ element.uom }}</span>
                }
                }
              </div>
            }
          </td>
        </ng-container>
        <ng-container matColumnDef="Amount">
          <th mat-header-cell *matHeaderCellDef>Amount
            @if (selectedSortColumn === 'Amount') {
              <span>
                <mat-icon (click)="toggleSortDirection()" class="sort-column">{{ sortDirection === 'asc' ? 'arrow_upward' : 'arrow_downward' }}</mat-icon>
              </span>
            }
          </th>
          <td mat-cell *matCellDef="let element">{{ (readOnly || (isOutsidePaymentSelection(element)) ? element.quantity : contractPayableQuantity(element)) * element.unit_price | currency:'USD' }}</td>
        </ng-container>
        <!-- G703 Columns for submitted pay apps -->
        <ng-container matColumnDef="Item">
          <th mat-header-cell *matHeaderCellDef class="g703-col-item">Item</th>
          <td mat-cell *matCellDef="let element" class="g703-col-item">{{ element.item }}</td>
        </ng-container>
        <ng-container matColumnDef="Description">
          <th mat-header-cell *matHeaderCellDef class="g703-col-description">Description</th>
          <td mat-cell *matCellDef="let element" class="g703-col-description">{{ element.description }}</td>
        </ng-container>
        <ng-container matColumnDef="Unit">
          <th mat-header-cell *matHeaderCellDef class="g703-col-unit">Unit</th>
          <td mat-cell *matCellDef="let element" class="g703-col-unit">{{ element.uom }}</td>
        </ng-container>
        <ng-container matColumnDef="OriginalQty">
          <th mat-header-cell *matHeaderCellDef class="g703-col-qty text-right">Original Qty</th>
          <td mat-cell *matCellDef="let element" class="g703-col-qty text-right">{{ element.original_quantity | number:'1.2-2' }}</td>
        </ng-container>
        <ng-container matColumnDef="COQty">
          <th mat-header-cell *matHeaderCellDef class="g703-col-qty text-right">CO Qty</th>
          <td mat-cell *matCellDef="let element" class="g703-col-qty text-right">{{ element.change_order_quantity | number:'1.2-2' }}</td>
        </ng-container>
        <ng-container matColumnDef="AdjustedQty">
          <th mat-header-cell *matHeaderCellDef class="g703-col-qty text-right">Adjusted Qty</th>
          <td mat-cell *matCellDef="let element" class="g703-col-qty text-right">{{ element.adjusted_quantity | number:'1.2-2' }}</td>
        </ng-container>
        <ng-container matColumnDef="QtyThisPeriod">
          <th mat-header-cell *matHeaderCellDef class="g703-col-qty text-right">This Period</th>
          <td mat-cell *matCellDef="let element" class="g703-col-qty text-right">{{ element.quantity | number:'1.2-2' }}</td>
        </ng-container>
        <ng-container matColumnDef="QtyPrevious">
          <th mat-header-cell *matHeaderCellDef class="g703-col-qty text-right">Previous</th>
          <td mat-cell *matCellDef="let element" class="g703-col-qty text-right">{{ element.quantity_previous | number:'1.2-2' }}</td>
        </ng-container>
        <ng-container matColumnDef="QtyToDate">
          <th mat-header-cell *matHeaderCellDef class="g703-col-qty text-right">To Date</th>
          <td mat-cell *matCellDef="let element" class="g703-col-qty text-right">{{ element.quantity_to_date | number:'1.2-2' }}</td>
        </ng-container>
        <ng-container matColumnDef="PercentComplete">
          <th mat-header-cell *matHeaderCellDef class="g703-col-percent text-right">% Complete</th>
          <td mat-cell *matCellDef="let element" class="g703-col-percent text-right">{{ element.percent_complete | number:'1.1-1' }}%</td>
        </ng-container>
        <ng-container matColumnDef="UnitPrice">
          <th mat-header-cell *matHeaderCellDef class="g703-col-price text-right">Unit Price</th>
          <td mat-cell *matCellDef="let element" class="g703-col-price text-right">{{ element.unit_price | currency:'USD' }}</td>
        </ng-container>
        <ng-container matColumnDef="G703Amount">
          <th mat-header-cell *matHeaderCellDef class="g703-col-amount text-right">Amount</th>
          <td mat-cell *matCellDef="let element" class="g703-col-amount text-right">{{ element.amount || (element.quantity * element.unit_price) | currency:'USD' }}</td>
        </ng-container>
        <ng-container matColumnDef="MaterialsStored">
          <th mat-header-cell *matHeaderCellDef class="g703-col-amount text-right">Stored (F)</th>
          <td mat-cell *matCellDef="let element" class="g703-col-amount text-right">{{ (element.moh?.F || 0) | currency:'USD' }}</td>
        </ng-container>
        <ng-container matColumnDef="StoredDelta">
          <th mat-header-cell *matHeaderCellDef class="g703-col-amount text-right">Stored Δ</th>
          <td mat-cell *matCellDef="let element" class="g703-col-amount text-right">{{ ((element.moh?.advance_added || 0) - (element.moh?.drawdown || 0)) | currency:'USD' }}</td>
        </ng-container>
        <ng-container matColumnDef="StoredCompletedTotal">
          <th mat-header-cell *matHeaderCellDef class="g703-col-amount text-right">G</th>
          <td mat-cell *matCellDef="let element" class="g703-col-amount text-right">{{ (element.moh?.G || ((element.amount || 0) + (element.moh?.F || 0))) | currency:'USD' }}</td>
        </ng-container>
        @if (selectedPayapp?.name === 'Unpaid' && !isContractorMode) {
          <ng-container matColumnDef="Status">
            <th mat-header-cell *matHeaderCellDef>Status
              @if (selectedSortColumn === 'Status') {
                <span>
                  <mat-icon (click)="toggleSortDirection()" class="sort-column">{{ sortDirection === 'asc' ? 'arrow_upward' : 'arrow_downward' }}</mat-icon>
                </span>
              }
            </th>
            <td mat-cell *matCellDef="let element">
            @if (isOutsidePaymentSelection(element)) {
              <div class="earlier-item-status">
                <span>{{ element.pay_app_status === 'deferred' ? 'Deferred' : deferredQuantity(element) > 0 ? 'Partially deferred' : 'Unpaid' }}</span>
                <button type="button" class="payapp-inline-link" [attr.data-testid]="'payapp-include-' + element.report_bid_item_id" (click)="includePriorItem(element)">Include in this pay app</button>
              </div>
              <div class="comment-text">{{ element.pay_app_comments }}</div>
            } @else {
            <div class="status-pill" [ngClass]="{
              'ready-status': (tempStatusMap[element.report_bid_item_id] || statusMap[element.report_bid_item_id]) === 'ready',
              'deferred-status': (tempStatusMap[element.report_bid_item_id] || statusMap[element.report_bid_item_id]) === 'deferred',
              'rejected-status': (tempStatusMap[element.report_bid_item_id] || statusMap[element.report_bid_item_id]) === 'rejected'
            }">
                <mat-select
                  #itemStatus
                  [attr.data-testid]="'payapp-status-' + element.report_bid_item_id"
                  [value]="statusSelectionValue(element)"
                  (selectionChange)="$event.value === 'partial' ? editPayableQuantity(element) : $event.value === 'exclude' ? includePriorItem(element) : onStatusChange(element.report_bid_item_id, $event.value); itemStatus.value = statusSelectionValue(element)"
                  panelClass="payapp-status-panel"
                  yPosition="below"
                  disableOptionCentering>
                  <mat-select-trigger>
                    {{ (tempStatusMap[element.report_bid_item_id] || statusMap[element.report_bid_item_id]) === 'deferred' ? 'Deferred' : (tempStatusMap[element.report_bid_item_id] || statusMap[element.report_bid_item_id]) === 'rejected' ? 'Rejected' : deferredQuantity(element) > 0 ? 'Partially deferred' : 'Ready' }}
                  </mat-select-trigger>
                  @if (statusSelectionValue(element) === 'partially-deferred') {
                    <mat-option value="partially-deferred" disabled>Partially deferred</mat-option>
                  }
                  <mat-option [ngClass]="{'selected-status-option': statusSelectionValue(element) === 'ready'}" value="ready">Ready</mat-option>
                  @if (canEdit && element.quantity > 0) {
                    <mat-option [attr.data-testid]="'payapp-allocate-' + element.report_bid_item_id" value="partial">{{ needsPartialPaymentReview(element) && contractPayableQuantity(element) <= 0 ? 'Defer in full…' : 'Partial payment…' }}</mat-option>
                  }
                  @if (includedPriorItems.has(element.report_bid_item_id)) {
                    <mat-option value="exclude">Remove from this payapp</mat-option>
                  }
                  <mat-option [ngClass]="{'selected-status-option': 'deferred' === (tempStatusMap[element.report_bid_item_id] || statusMap[element.report_bid_item_id])}" value="deferred">Deferred</mat-option>
                  <mat-option [ngClass]="{'selected-status-option': 'rejected' === (tempStatusMap[element.report_bid_item_id] || statusMap[element.report_bid_item_id])}" value="rejected">Rejected</mat-option>
                </mat-select>
                <mat-icon class="status-chevron" svgIcon="chevron-down" />
              </div>
              @if (commentsMap[element.report_bid_item_id]) {
                <div class="comment-text" (click)="statusMap[element.report_bid_item_id] === 'ready' && payableQuantity(element) < element.quantity ? editPayableQuantity(element) : onStatusChange(element.report_bid_item_id, statusMap[element.report_bid_item_id])">
                  {{ commentsMap[element.report_bid_item_id] }}
                </div>
              }
            }
            </td>
          </ng-container>
        }
        @if (isContractorMode) {
          <ng-container matColumnDef="Status">
            <th mat-header-cell *matHeaderCellDef>Status
              @if (selectedSortColumn === 'Status') {
                <span>
                  <mat-icon (click)="toggleSortDirection()" class="sort-column">{{ sortDirection === 'asc' ? 'arrow_upward' : 'arrow_downward' }}</mat-icon>
                </span>
              }
            </th>
            <td mat-cell *matCellDef="let element">
            <div class="status-pill" [ngClass]="{
              'agree-status': (tempContractorStatusMap[element.report_bid_item_id] || contractorStatusMap[element.report_bid_item_id]) === 'agree',
              'disagree-status': (tempContractorStatusMap[element.report_bid_item_id] || contractorStatusMap[element.report_bid_item_id]) === 'disagree'
            }">
                <mat-select
                  [value]="tempContractorStatusMap[element.report_bid_item_id] || contractorStatusMap[element.report_bid_item_id]"
                  (selectionChange)="onContractorStatusChange(element.report_bid_item_id, $event.value)"
                  panelClass="payapp-status-panel"
                  yPosition="below"
                  disableOptionCentering>
                  <mat-option [ngClass]="{'selected-status-option': 'agree' === (tempContractorStatusMap[element.report_bid_item_id] || contractorStatusMap[element.report_bid_item_id])}" value="agree">Agree</mat-option>
                  <mat-option [ngClass]="{'selected-status-option': 'disagree' === (tempContractorStatusMap[element.report_bid_item_id] || contractorStatusMap[element.report_bid_item_id])}" value="disagree">Disagree</mat-option>
                </mat-select>
                <mat-icon class="status-chevron" svgIcon="chevron-down" />
              </div>
              @if (contractorCommentsMap[element.report_bid_item_id]) {
                <div class="comment-text" (click)="onContractorStatusChange(element.report_bid_item_id, contractorStatusMap[element.report_bid_item_id])">
                  {{ contractorCommentsMap[element.report_bid_item_id] }}
                </div>
              }
            </td>
          </ng-container>
        }
        <tr mat-header-row *matHeaderRowDef="showG703View ? g703Columns : displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: showG703View ? g703Columns : displayedColumns;"></tr>
      </table>
    </div>
  }

  <!-- No Data for Unpaid View -->
  @if (showPartialPaymentReview && !partialPaymentReviewCount) {
    <div class="no-data" data-testid="payapp-review-complete">No deferrals need review. Show all items to continue.</div>
  }
  @if (!showG703View && !showPartialPaymentReview && !displayedItems?.length) {
    <div class="no-data">
      No records found.
    </div>
  }

  <div class="paginator-wrapper">
    @if ((!searchControl.value || showDeferredItems) && !showPartialPaymentReview) {
      <app-paginator
        (pageChanged)="pageChanged($event)"
        [itemsPerPage]="pagination.pageSize"
        [totalItems]="pagination.length"
        class="paginator"
        >
      </app-paginator>
    }
  </div>
</div>
